module.exports = __webpack_public_path__ + "static/media/btre.abe94de3.jpg";